import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
export function TextAreaInput({ id, label, value, onChange, placeholder = '', rows = 3, className = 'brutal-input', }) {
    const handleChange = useCallback((e) => {
        onChange(e.target.value);
    }, [onChange]);
    const labelStyle = {
        fontSize: '0.75rem',
        fontWeight: '600',
        color: '#999999',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        marginBottom: '0.375rem',
        display: 'block',
    };
    const textareaStyle = {
        width: '100%',
        maxWidth: '320px',
        backgroundColor: '#141414',
        border: '2px solid #333333',
        borderRadius: 0,
        color: '#f5f5f5',
        padding: '10px 14px',
        fontFamily: 'inherit',
        fontSize: '13px',
        lineHeight: '1.4',
        minHeight: `${rows * 1.4}rem`,
        resize: 'vertical',
        transition: 'border-color 0.15s ease',
        boxSizing: 'border-box',
    };
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', gap: '0.375rem', maxWidth: '320px' }, children: [_jsx("label", { htmlFor: id, style: labelStyle, children: label }), _jsx("textarea", { id: id, value: value, onChange: handleChange, placeholder: placeholder, rows: rows, style: textareaStyle })] }));
}
